<app-side-menu>
  <div class="prf-page">
    <header class="prf-header">
      <div class="prf-header-inner">
        <button type="button" class="prf-btn-back" (click)="cancel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>
          Voltar
        </button>
        <div class="prf-header-divider" aria-hidden="true"></div>
        <div class="prf-header-title-block">
          <div class="prf-header-icon-wrap" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
          </div>
          <div>
            <h1 class="prf-title">{{ pageTitle() }}</h1>
            <p class="prf-subtitle">Descreva a necessidade do setor; preço e fornecedor entram depois na cotação.</p>
          </div>
        </div>
      </div>
    </header>

    <main class="prf-main">
      <div *ngIf="error()" class="prf-banner prf-banner--warn" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" x2="12" y1="9" y2="13"/><line x1="12" x2="12.01" y1="17" y2="17"/></svg>
        <p class="prf-banner-text">{{ error() }}</p>
      </div>

      <div *ngIf="showCostCenterBanner()" class="prf-banner prf-banner--info" role="status">
        <svg class="prf-banner-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
        <div>
          <p class="prf-banner-text prf-banner-text--strong">
            Centro de custo:
            <strong class="prf-cc-strong">{{ costCenterLabel() }}</strong>
          </p>
        </div>
      </div>

      <div class="prf-card">
        <div *ngIf="isSaving()" class="prf-loading">
          <div class="prf-spinner" role="status">
            <span class="visually-hidden">Salvando...</span>
          </div>
        </div>

        <form (ngSubmit)="submit()" novalidate>
          <div class="prf-card-body">
            <section class="prf-section">
              <div class="prf-field">
                <label for="prf-descricao" class="prf-label">
                  Descrição da solicitação <span class="prf-req">*</span>
                </label>
                <textarea
                  id="prf-descricao"
                  name="descricao"
                  rows="3"
                  class="prf-textarea"
                  [class.prf-input-invalid]="descricaoSolicitacaoInvalida()"
                  [value]="description()"
                  (input)="setDescription($any($event.target).value)"
                  placeholder="Ex.: Necessidade de novos equipamentos para os colaboradores recém-contratados."></textarea>
              </div>

              <div class="prf-grid-top">
                <div class="prf-field">
                  <label for="prf-prioridade" class="prf-label">
                    Prioridade <span class="prf-req">*</span>
                  </label>
                  <select
                    id="prf-prioridade"
                    name="prioridade"
                    class="prf-select"
                    [value]="priorityKey()"
                    (change)="setPriorityKey($any($event.target).value)">
                    <option value="baixa">Baixa</option>
                    <option value="normal">Normal</option>
                    <option value="alta">Alta</option>
                    <option value="urgente">Urgente</option>
                  </select>
                </div>
                <div class="prf-field prf-field--span2">
                  <label for="prf-observacoes" class="prf-label">
                    Observações <span class="prf-opt">(Opcional)</span>
                  </label>
                  <input
                    id="prf-observacoes"
                    name="observacoes"
                    type="text"
                    class="prf-input"
                    [value]="notes()"
                    (input)="setNotes($any($event.target).value)"
                    placeholder="Informações adicionais relevantes para o setor de compras..." />
                </div>
              </div>
            </section>

            <hr class="prf-hr" />

            <section class="prf-section prf-section--items">
              <div class="prf-items-head">
                <div class="prf-items-head-left">
                  <svg class="prf-icon-muted" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="8" x2="21" y1="6" y2="6"/><line x1="8" x2="21" y1="12" y2="12"/><line x1="8" x2="21" y1="18" y2="18"/><line x1="3" x2="3.01" y1="6" y2="6"/><line x1="3" x2="3.01" y1="12" y2="12"/><line x1="3" x2="3.01" y1="18" y2="18"/></svg>
                  <h2 class="prf-items-title">Itens</h2>
                </div>
                <button type="button" class="prf-btn-add-item" (click)="adicionarItem()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
                  Adicionar item
                </button>
              </div>

              <div class="prf-item-list">
                <div *ngFor="let item of itens(); trackBy: trackByItemId" class="prf-item-card">
                  <div class="prf-item-inner">
                    <div class="prf-item-row">
                      <div class="prf-item-col-desc">
                        <label class="prf-label prf-label--sm">
                          O que o setor precisa <span class="prf-req">*</span>
                        </label>
                        <input
                          type="text"
                          class="prf-input"
                          [class.prf-input-invalid]="descricaoInvalida(item)"
                          [value]="item.descricao"
                          (input)="onItemDescricao(item.id, $event)"
                          placeholder="Ex: Monitor 24 polegadas" />
                      </div>
                      <div class="prf-item-col-qty">
                        <div class="prf-qty-unit">
                          <div class="prf-half">
                            <label class="prf-label prf-label--sm">Qtd <span class="prf-req">*</span></label>
                            <input
                              type="number"
                              class="prf-input"
                              [class.prf-input-invalid]="qtdInvalida(item)"
                              [value]="item.qtd"
                              min="1"
                              (input)="onItemQtd(item.id, $event)" />
                          </div>
                          <div class="prf-half">
                            <label class="prf-label prf-label--sm">Unidade <span class="prf-req">*</span></label>
                            <input
                              type="text"
                              class="prf-input prf-input-upper"
                              [class.prf-input-invalid]="unidadeInvalida(item)"
                              [value]="item.unidade"
                              placeholder="UN"
                              (input)="onItemUnidade(item.id, $event)" />
                          </div>
                        </div>
                      </div>
                      <div class="prf-item-col-trash">
                        <button
                          type="button"
                          class="prf-btn-trash"
                          (click)="removerItem(item.id)"
                          title="Remover item"
                          [disabled]="itens().length === 1"
                          [class.prf-btn-trash--disabled]="itens().length === 1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
                        </button>
                      </div>
                    </div>
                    <div class="prf-field prf-field--just">
                      <label class="prf-label prf-label--sm">
                        Justificativa <span class="prf-opt">(Opcional)</span>
                      </label>
                      <textarea
                        rows="2"
                        class="prf-textarea"
                        [value]="item.justificativa"
                        (input)="onItemJustificativa(item.id, $event)"
                        placeholder="Por que este item é necessário? Descreva detalhes ou motivos específicos..."></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div class="prf-card-footer">
            <button type="button" class="prf-btn-cancel" (click)="cancel()">Cancelar</button>
            <button
              type="submit"
              class="prf-btn-submit"
              [disabled]="isSaving() || !resolvedCostCenterId()">
              <span *ngIf="!isSaving()" class="prf-btn-submit-inner">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>
                {{ submitButtonLabel() }}
              </span>
              <span *ngIf="isSaving()" class="prf-btn-submit-inner">
                {{ isEditMode() ? 'Salvando...' : 'Enviando...' }}
              </span>
            </button>
          </div>
        </form>
      </div>
    </main>
  </div>
</app-side-menu>
